<div class="control-input control-input--appearance_bordered"><textarea class="control-input__element" v-bind="$attrs"></textarea></div>